<template>
  <div class="parent-box">
    <transition name="modal">
      <div class="">
        <div class="">
          <br />
          <br />

          <div class="modal-container">
            <div class="modal-headerxx"></div>
            <div class="modal-body">
              <div>
                <h2 class="text-center">
                  ARNERGY GENERAL TERMS AND CONDITIONS FOR LEASE TO OWN SOLAR POWER SYSTEM SERVICES
                </h2>
              </div>
              <hr />
              <div>
                <p class="text-justify text-dark">
                  In these terms and conditions (the “Terms”), “Arnergy” means Arnergy Solar Limited and the “Consumer”
means you the Consumer. Arnergy and the Consumer are also individually referred to as a Party and
collectively referred to as the Parties. Please read the following terms before proceeding with your payment.
By clicking register, the Consumer agrees to be bound by these Terms and the Terms contained herein and any
terms made available via a hyperlink shall constitute a lease to own agreement between Arnergy and the
Consumer. By choosing to purchase an Arnergy solar power system under the lease-to-own model, the
Consumer agrees to provide the required documentation for Arnergy’s customer onboarding requirements
and credit check process and the Consumer agrees to be bound by these Terms.
                </p>
                <p class="text-justify text-dark">
                  Be rest assured that all information provided is treated as confidential. See clause 11 (Confidentiality).
Arnergy reserves the right to modify these Terms at any time. Arnergy shall provide the Consumer with notice
of the modifications via email communication at least five (5) days before the date they become effective.
                </p>

                <div>
                  <h3 class="text-left text-dark">
                    1. DEFINITIONS AND INTERPRETATION
                  </h3>
                  <div className="child-agree ml-5 pl-5">
                    <p class="text-justify text-dark">
                      1.1 In these Terms, unless the context otherwise admits or requires, the following expressions
                      shall have the meanings set against them:
                      <p class="text-justify text-dark pl-4">Terms means this Solar System Lease Terms and Conditions;</p>
                      <p class="text-justify text-dark pl-4">Applicable Law means all laws in force and effect as of the date hereof and which may be
enacted or brought into force and effect hereinafter in Nigeria, including statutes, rules,
regulations, directions, bye-laws, notifications, ordinances and judgments having force of law,
or any final interpretation by a court of law having jurisdiction over the matter in question as
may be in force and effect during the subsistence of these Terms;</p>
                      <p class="text-justify text-dark pl-4">Business Day means a day other than a Saturday or Sunday on which banks are ordinarily
open for the transaction of normal banking business in the Federal Republic of Nigeria;</p>
                      <p class="text-justify text-dark pl-4">Confidential Information means information of commercial value, in whatever form or
medium, which has been kept confidential by the Party from whom the information
originates and which has not come into the public domain during the term of these Terms in
breach of any obligation of confidence, including information relating to the applications,
software, or any of its constituent parts, the source codes, commercial or technical
know-how, technology, information pertaining to business operations and strategies, and
information pertaining to customers and pricing;</p>
                      <p class="text-justify text-dark pl-4">Effective Date means the date the System is switched on and installed at the Consumer’s
Location;</p>
                      <p class="text-justify text-dark pl-4">IP Rights means patents, rights to inventions, copyright and related rights, trademarks and
service marks, trade and business names, rights in goodwill or to sue for passing off or unfair
competition, rights in designs, patents and any other intellectual property rights, in each case
whether registered or unregistered and including all applications for, and renewals or
extensions of, such rights and all similar or equivalent rights or forms of protection in any
part of the world;</p>
                      <p class="text-justify text-dark pl-4">Lease Period means the agreed duration of the lease which commences from the Effective
Date;</p>
                      <p class="text-justify text-dark pl-4">Location means the agreed address of the Consumer where the System is installed;</p>
                      <p class="text-justify text-dark pl-4">Purchase Option means the right of the Consumer to purchase the System at the end of the
Lease Period;</p>
                      <p class="text-justify text-dark pl-4">Rental Payments means the sum payable by the Consumer to Arnergy on a monthly basis
during the course of the Lease Period;</p>
                      <p class="text-justify text-dark pl-4">Services means the design, installation, commissioning and maintenance of the System at
the Location, and the provision of the solar power system services in accordance with these
Terms; and</p>
                      <p class="text-justify text-dark pl-4">System means the solar power system, including the solar modules/panels (if applicable),
inverter system, battery storage, remote monitoring technology and other accessories
thereto.</p>
                    <p class="text-justify text-dark">
                      1.2 Arnergy holds title to and ownership of the System for
                      the duration of the lease period to be agreed between
                      Arnergy and the Client.The headings and titles to the clause and paragraphs in these Terms, are inserted for
convenience only and shall not control or affect the construction, meaning or interpretation
of any provision of these Terms.
                    </p>
                  </div>
                </div>

                <div>
                  <h3 class="text-left text-dark">2. COMMENCEMENT AND DURATION</h3>
                  <div className="child-agree ml-5 pl-5">
                    <p class="text-justify text-dark">
                      The Lease Period shall commence on the Effective Date for the duration of the Lease Period unless
and until terminated in accordance with clause 15.
                    </p>
                  </div>
                </div>

                <div>
                  <h3 class="text-left text-dark">3. NATURE OF THESE TERMS</h3>
                  <div className="child-agree ml-5 pl-5">
                    <p class="text-justify text-dark">
                      Arnergy shall let the System, and the Consumer agrees to take it on a lease for use at the Location,
subject to these Terms.
                    </p>
                  </div>
                </div>

                <div>
                  <h3 class="text-left text-dark">
                    4. OWNERSHIP, DELIVERY AND RISK OF THE ARNERGY SYSTEM
                  </h3>
                  <div className="child-agree ml-5 pl-5">
                    <p class="text-justify text-dark">
                      4.1 Arnergy holds title to, and ownership of the System and all additional assets and equipment
installed as part of the System in connection with the Services for the duration of the Lease
Period.
                    </p>
                    <p class="text-justify text-dark">
                      4.2 Arnergy shall deliver the System to the Location. Upon the completion of the delivery and
installation of the System, the Consumer shall provide Arnergy with an executed copy of the
certificate of acceptance and by doing so, the Consumer will be deemed to have
acknowledged delivery of and accepted the System.
                    </p>
                    <p class="text-justify text-dark">
                      4.3 The Consumer shall ensure the reasonable safety of the physical security of the System from
the Effective Date. The Consumer shall exercise reasonable care in the use of the System in
the manner recommended by Arnergy.
                    </p>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">5. CONSIDERATION & PAYMENTS</h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        5.1 Prior to the installation date, the Consumer shall pay to Arnergy, an initial deposit and a
caution fee. The caution fee shall be applied to the last month of the Lease Period provided
that there are no sums owed to Arnergy prior to the last month of the Lease Period.
                      </p>
                      <p class="text-justify text-dark">
                        5.2 The Consumer shall pay to Arnergy, in respect of the Lease Period, the Rental Payments. The
Consumer will not claim capital allowances on the System during the Lease Period.
                      </p>
                      <p class="text-justify text-dark">
                        5.3 The Services are provided on a pre-paid basis. Arnergy shall invoice the Consumer for the
Rental Payment in advance for the Services to be provided in the following month.
                      </p>
                      <p class="text-justify text-dark">
                        5.4 The Services shall be activated by Arnergy where the Consumer has made the requisite
monthly pre- payment for a relevant month.
                      </p>
                      <p class="text-justify text-dark">
                        5.5 We may review the monthly payments subject to prevailing market conditions. Arnergy shall
promptly notify the Consumer in such instances and appropriate changes shall be made
immediately and become binding on the Consumer.
                      </p>
                      <p class="text-justify text-dark">
                        5.6 The Rental Payments shall be non-refundable and payable in advance for each month that
the System is at the Location, regardless of whether the solar power was consumed or not
consumed in any given month.
                      </p>
                      <p class="text-justify text-dark">
                        5.7 The Consumer acknowledges that where payments fall due on a day which is not a business
day, such payments are to be made on the preceding business day.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">
                      6. PURCHASE OPTION
                    </h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        The Parties agree that the Consumer shall have the automatic right to exercise the Purchase Option
upon the expiration of the Lease Period PROVIDED THAT all outstanding payments and obligations
due to Arnergy from the Consumer under this lease have been discharged. The Consumer shall upon
the exercise of the Purchase Option have ownership of the System transferred from Arnergy to the
Consumer. When the exercise of the Purchase Option has been completed in accordance with the
terms of this clause 6, ownership and title to the System shall automatically pass to the Consumer
without any further act or deed and in the condition and at the Location.
                      </p>
                    </div>
                  </div>
                </div>

                <div>
                  <h3 class="text-left text-dark">
                    7. SCOPE OF WORK FOR THE INSTALLATION SERVICE
                  </h3>
                  <div className="child-agree ml-5 pl-5">
                    <p class="text-justify text-dark">
                      7.1 Arnergy’s installation scope of work includes the following:
                    </p>
                    <p class="text-justify text-dark pl-4">
                      7.1.1 Installation of the solar panels on the roof or a location provided by the
Consumer (where applicable);
                    </p>
                    <p class="text-justify text-dark pl-4">
                      7.1.2 Installation of the bluebox at the Consumer’s preferred location which must be
well ventilated, covered from rainfall or water; and
                    </p>
                    <p class="text-justify text-dark">
                      7.2 It is agreed and acknowledged that, Arnergy’s scope of work for the installation does not
include the following:
                    </p>
                    <p class="text-justify text-dark pl-4">
                      7.2.1 Rewiring of the Consumer's facility where the wiring architecture of the
building is a surface wiring; and
                    </p>
                    <p class="text-justify text-dark pl-4">
                      7.2.2 Interconnection of multiple buildings where the buildings electrical wiring are
not interconnected.
                    </p>
                    <p class="text-justify text-dark pl-4">
                      For the out of scope work set out above, the Consumer shall be responsible for the associated
work required for the successful completion of the installation and the fees.
                    </p>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">8. MONITORING OF THE SYSTEM, POWER OVERLOAD AND SYSTEM REPAIRS</h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        8.1 Arnergy and the Consumer shall have access to round the clock technology to monitor the
System. This shall be at no additional cost to the Consumer.
                      </p>
                      <p class="text-justify text-dark">
                        8.2 Arnergy shall conduct routine maintenance of the System quarterly and corrective
maintenance where required.
                      </p>
                      <p class="text-justify text-dark">
                        8.3 The Consumer shall have no justification to withhold, omit, halt or delay making the required
Rental Payments where the Consumer failed or omitted to immediately notify Arnergy of the
need for a corrective maintenance or repair. The full monthly Rental Payment shall remain
due and payable by the Consumer in such instance.
                      </p>
                      <p class="text-justify text-dark">
                        8.4 The Consumer authorises Arnergy and its designated personnel to have access to inspect the
System where Arnergy has provided the 12 hours prior notice to the Consumer by SMS or
email ahead of maintenance inspections (between the hours of 9.00am-5.00pm).
                      </p>
                      <p class="text-justify text-dark">
                        8.5 Where the actual load on the System, as used by the Consumer, is in excess of the System’s
specified load capacity already agreed between the Consumer and Arnergy, this causes
disruptions to the System and affects the reliability. Where the Consumer intends to effect an
increase in its load requirement and System usage, it is the Consumer’s responsibility to
notify Arnergy promptly to avoid disruptions due to excess load. Arnergy will advise on any
upgrades to the System that is required to give effect to the changes.
                      </p>
                      <p class="text-justify text-dark">
                        8.6 Arnergy shall maintain and repair the System at no additional cost to the Consumer, unless
the damage to the System was caused by negligence or willful misconduct of the Consumer
and/or its affiliates, in which case, the Consumer shall bear the cost for repair and replacing
all worn and damaged parts of the System.
                      </p>
                      <p class="text-justify text-dark">
                        8.7 Only authorised personnel of Arnergy are permitted to repair the System.
                      </p>
                      <p class="text-justify text-dark">
                        8.8 Arnergy is committed to its environmental and sustainability objectives. Therefore, Arnergy
must be carried along on any disposal of any part of the System for proper disposal in
accordance with generally accepted health and safety standards.
                      </p>
                      <p class="text-justify text-dark">
                        8.9 Where any payment is required from the Consumer under clause 8.5 and 8.6, such cost shall
form part of the Rental Payments and shall be prorated for the remainder of the Lease
Period.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">
                      9. OBLIGATIONS OF THE CONSUMER
                    </h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        9.1 The Consumer shall act reasonably and cooperate with Arnergy to enable Arnergy deliver
and install the System in line with these Terms.
                      </p>
                      <p class="text-justify text-dark">
                        9.2 The Consumer shall provide a suitable space on the roof or cleared level land areas, free of
any debris or other encumbrances for the System at the Location and ensure that the System
benefits from valid rights of use of all land and other easements necessary to install and
operate the System at the Location during the Lease Period.
                      </p>
                      <p class="text-justify text-dark">
                        9.3 The Consumer agrees that it shall not during the Lease Period modify, move, relocate,
sub-lease, charge, mortgage, encumber by any means or tamper with or otherwise handle
the System without the express prior written consent of Arnergy.
                      </p>
                      <p class="text-justify text-dark">
                        9.4 The Consumer shall take all reasonable measures necessary to prevent any damage to the
System. This includes without limitation ensuring that the System is located in a vandalism-
proof perimeter at the Location.
                      </p>
                      <p class="text-justify text-dark">
                        9.5 Notwithstanding any other provision of these Terms, the Consumer shall be responsible for
any damage, destruction or loss of the System attributable to the negligence, or willful
misconduct of the Consumer and the Consumer shall accordingly cause the System or
damaged part of the System to be rebuilt or replaced at its cost. While the System is being
rebuilt or replaced, the Consumer’s obligation to make the Rental Payments shall continue in
force and effect.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">10. WARRANTIES</h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        10.1 If the System is materially damaged or destroyed, or suffers any other material loss, or the
use thereof is otherwise diminished to render impracticable or unreasonable the continued
production of energy, Arnergy shall repair or replace the System in the earliest practical date
in accordance with these Terms. Provided that where the same is caused by negligence or
damage by the Consumer or any of its agents, such repair will be at the cost of the Consumer.
Where the Consumer’s operations are or are reasonably expected to be hindered by any such
damage or where there are any delays expected in repairing or replacing the System
depending on the extent of the damage, Arnergy shall promptly notify the Consumer and
Arnergy shall put a stop gap measure in place for provision of power until the repair or
replacement is concluded.
                      </p>
                      <p class="text-justify text-dark">
                        10.2 Any stop gap used pending the replacement or repair of the System shall adequately serve
the same function of the System as provided herein.
                      </p>
                      <p class="text-justify text-dark">
                        10.3 Arnergy warrants that the System is free from defects in materials and workmanship for a
period of five (5) years from the Effective Date. This warranty shall not apply to an abuse,
damage, alteration or misuse of the System by the gross negligence or willful misconduct of
the Consumer.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">
                      11. CONFIDENTIAL INFORMATION & PUBLICITY
                    </h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        11.1 Each Party shall safeguard, treat as confidential and not use for the purposes of its own
business any Confidential Information which relates to the business and affairs of either
Party.
                      </p>
                      <p class="text-justify text-dark">
                        11.2 Notwithstanding Clause 11.1, each Party may at any time disclose any Confidential
Information, following reasonable consultation with the other Party, if the disclosure is made
in good faith in the circumstances set out below and, in each case, only to the extent
reasonably necessary:
                      </p>
                      <p class="text-justify text-dark pl-4">
                        11.2.1 if it is required by law, the terms of a grant, a court of competent jurisdiction or any
government or regulatory authority; or
                      </p>
                      <p class="text-justify text-dark pl-4">
                        11.2.2 to its own employees, directors or consultants where such disclosure is required for
the exercise of the relevant Party’s obligations under these Terms.
                      </p>
                      <p class="text-justify text-dark">
                        11.3 In the case of a company, the Consumer hereby grants Arnergy the right to use the name and
service marks of the Consumer in its marketing materials or other oral, electronic, or written
promotions, which shall include naming the Consumer as a client of Arnergy and a brief
scope of services provided. Either Party may elect to issue a press or social media
promotional release related to this Agreement. In doing so, any release shall be approved by
the other Party and such approval shall not be unreasonably withheld.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">
                      12. INDEMNIFICATION AND LIMITATION OF LIABILITY
                    </h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        12.1 Either Party (the "Indemnifying Party") shall indemnify and hold the other Party (the
"Indemnified Party") harmless from and against any loss, damage, expense or liability
incurred by the Indemnified Party as a consequence of a breach of the Indemnifying Party or
its agents, employees, directors, officers, managers, members, of its obligations under these
Terms. In the event that there are any third-party claims, losses, liabilities and costs caused
by the Indemnifying Party’s breach/negligence, the Indemnifying Party shall be solely liable.
In the event that there is contributory liability on the part of the Indemnified Party and/or
the Indemnified Party is equally responsible for the liability, the consequence of the liability
shall be shared equally in proportion to each Party’s relative degree of fault.
                      </p>
                      <p class="text-justify text-dark">
                        12.2 Arnergy shall not be liable to the Consumer, whether in contract, tort (including negligence),
breach of statutory duty, or otherwise, for any loss of profit, or for any indirect or
consequential loss arising under or in connection with these Terms or the Consumer’s use of
the System.
                      </p>
                      <p class="text-justify text-dark">
                        12.3 Under no circumstances will the aggregate liability of Arnergy or its affiliates arising out of
or related to this Agreement, (including but not limited to warranty claims), regardless of the
forum and regardless of whether any action or claim is based on contract, tort (including
negligence), strict liability, or any other legal or equitable theory, exceed the 3 months’ value
of the Rental Payment. The foregoing limitations will not in any way limit the Consumer’s
payment obligations under clause 5 above.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">
                      13. DEFAULT
                    </h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        13.1 Should the Consumer fail to effect prompt payment of the Rental Payments and such other
amounts payable under these Terms, or where there is negligent or willful damage to the
System by the Consumer, Arnergy may (without prejudice to other rights and remedies of
Arnergy) suspend part or all of the Services until payment has been made in full.
                      </p>
                      <p class="text-justify text-dark">
                        13.2 Unauthorized tampering/hacking of the System by the Consumer is a breach of Arnergy’s
legal ownership of the System and any IP Rights of Arnergy. Arnergy reserves the right to
immediately decommission the System (and decommissioning fees shall be payable by the
Consumer) and/or take legal action in such instances.
                      </p>
                      <p class="text-justify text-dark">
                        13.3 Where an invoice remains unpaid for a period of thirty (30) days from the date of receipt of
an invoice for payment, Arnergy reserves the right to report the default to the national credit
bureau and Arnergy can also provide information required to the credit bureau with regards
to these Terms.
                      </p>
                      <p class="text-justify text-dark">
                        13.4 Arnergy shall have the right to decommission the System from the Location in the below
instances:
                      </p>
                      <p class="text-justify text-dark pl-4">
                        13.4.1 Willful or negligent damage to the System by the Consumer/and or its affiliates
and the Consumer is reluctant to bear responsibility for repairs; or
                      </p>
                      <p class="text-justify text-dark pl-4">
                        13.4.2 Non-payment for a period of thirty (30) days from the date of receipt of an
invoice for payment; or
                      </p>
                      <p class="text-justify text-dark pl-4">
                        13.4.3 Unauthorized tampering/hacking of the System by the Consumer.; or
                      </p>
                      <p class="text-justify text-dark pl-4">
                        13.4.4 Complete abandonment of the System.
                      </p>
                      <p class="text-justify text-dark">
                        13.5 The Consumer hereby authorises Arnergy and its designated personnel to have access and
enter the Location to decommission the System in accordance with these Terms.
                      </p>
                      <p class="text-justify text-dark">
                        13.6 Where Arnergy is unable to take possession of the System in accordance with the provisions
of clauses 13.4 and 13.5, the Consumer shall be liable to pay to Arnergy N500,000.00 as
default rate or liquidated damages for each day which the Consumer remains in possession
of the System. Until the System has been returned or repossessed, the Consumer shall be
solely responsible for its safe keeping.
                      </p>
                      <p class="text-justify text-dark">
                        13.7 For the avoidance of doubt, any outstanding payments due to Arnergy shall continue to
accrue during the default and remedy events set out in this clause 13 until the outstanding
payment is paid to Arnergy.
                      </p>
                      <p class="text-justify text-dark">
                        13.8 Where the Consumer has interest in continued use of the Services, accrued interest shall be
payable by the Consumer for re-activation of the System.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">
                      14. SWITCH TO ALTERNATIVE BUSINESS MODEL AND SYSTEM UPGRADE
                    </h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        14.1 The Consumer may opt to switch to an alternative business model of Arnergy. In the event
the Consumer would like to switch to the outright sale model, the System will be purchased
by the Consumer at the outright sales price communicated by Arnergy to the Consumer.
                      </p>
                      <p class="text-justify text-dark">
                        14.2 The Consumer may also opt to upgrade to a higher System, and Arnergy will review such
requests provided that the Consumer has consistently paid the Rental Payments in previous
months and is not in breach of any provision of these Terms.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">
                      15. TERMINATION
                    </h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        15.1 The provision of these Terms shall terminate in any of the following instances:
                      </p>
                      <p class="text-justify text-dark pl-4">
                        15.1.1 where the Purchase Option is exercised at the end of the Lease Period;
                      </p>
                      <p class="text-justify text-dark pl-4">
                        15.1.2 where there is a default by the Consumer in the circumstances stated in clause
13 above; or
                      </p>
                      <p class="text-justify text-dark pl-4">
                        15.1.3 the other Party commits a material breach of any of these Terms and such
breach is irremediable or (if such breach is remediable) fails to remedy that
breach within a period of thirty (30) days after being notified in writing to do
so; or
                      </p>
                      <p class="text-justify text-dark pl-4">
                        15.1.4 the Consumer or any guarantor of the Consumer’s obligations is unable or
admits in writing its inability to pay its debts as they fall due.
                      </p>
                      <p class="text-justify text-dark pl-4">
                        15.1.5 In the case of a company, where any of the following occurs in relation to the
Consumer:
                      </p>
                      <p class="text-justify text-dark pl-3">
                        15.1.5.1 the suspension of payments, a moratorium of any indebtedness,
winding up, dissolution, or reorganisation (by way of voluntary
arrangement, scheme of arrangement or otherwise) other than a
solvent liquidation or reorganisation;
                      </p>
                      <p class="text-justify text-dark pl-3">
                        15.1.5.2 a composition, compromise, assignment or arrangement with any
creditor; or
                      </p>
                      <p class="text-justify text-dark pl-3">
                        15.1.5.3 the appointment of a liquidator (other than in respect of a solvent
liquidation), receiver, manager or other similar officer in respect of the
Consumer or any of its assets, except that no breach of this Agreement
will occur under this clause in the case of an application for winding-up
presented by a creditor which is contested in good faith and with due
process and diligence and is discharged, stayed, dismissed or struck out
within forty-five (45) days of commencement.
                      </p>
                      <p class="text-justify text-dark pl-3">
                        15.1.5.4 where creditors’ process any expropriation, attachment, sequestration,
distress or execution or analogous event that affects the System.
                      </p>
                      <p class="text-justify text-dark pl-3">
                        15.1.5.5 the authority or ability of the Consumer to conduct all of its business is
limited or wholly or substantially curtailed by any seizure,
expropriation, nationalisation, compulsory acquisition, intervention,
restriction or other action by or on behalf of any authority in relation to
any of its assets or the shares in the Consumer.
                      </p>
                      <p class="text-justify text-dark">
                        15.2 Arnergy shall retrieve the System from the Location (at the cost of the Party responsible for
the termination) following the termination of the provision of these Terms under sub clauses
14.1.2-14.1.5. 
                      </p>
                      <p class="text-justify text-dark">
                        15.3 Notwithstanding termination of the provisions of these Terms, in accordance with this clause
14, the following clauses shall continue to have effect:
                      </p>
                      <p class="text-justify text-dark pl-4">
                        15.3.1 Definitions and Interpretation (Clause 1);
                      </p>
                      <p class="text-justify text-dark pl-4">
                        15.3.2 Confidentiality & Publicity (Clause 11);
                      </p>
                      <p class="text-justify text-dark pl-4">
                        15.3.3 Notices (clause 16);
                      </p>
                      <p class="text-justify text-dark pl-4">
                        15.3.4 No Implied Waiver, Entire Terms, Counterparts, Severability (Clauses 17.1,
17.2, 17.5 and 17.6); and
                      </p>
                      <p class="text-justify text-dark pl-4">
                        15.3.5 Governing Law and Dispute Resolution (Clause 18).
                      </p>
                      <p class="text-justify text-dark">
                        15.4 A termination of these Terms shall be without prejudice to the rights of either Party that had
accrued prior to the date of termination.
                      </p>
                      <p class="text-justify text-dark">
                        15.5 For the avoidance of doubt, the Consumer shall not be entitled to a refund of any Rental
Payments upon termination.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">
                      16. NOTICES
                    </h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        16.1 Any notices, request or other communication to be given or made under the provision of
these Terms shall be in writing and be delivered by hand, airmail or e-mail to, (i) Arnergy’s
details specified below, (ii) the Consumer’s contact details and address as notified to Arnergy
as part of this onboarding process; and (iii) at such other address as such Party notifies in
writing to the other Party from time to time:
                      </p>
                      <p class="text-justify text-dark pl-4">
                        To: Arnergy
                      </p>
                      <p class="text-justify text-dark pl-4">
                        Name: Arnergy Solar Limited
                      </p>
                      <p class="text-justify text-dark pl-4">
                        Address: 1, Industrial Avenue, Ilupeju, Lagos
                      </p>
                      <p class="text-justify text-dark pl-4">
                        Email: customer.service@arnergy.com
                      </p>
                      <p class="text-justify text-dark">
                        16.2 A notice is deemed to have been received:
                      </p>
                      <p class="text-justify text-dark pl-4">
                        16.2.1 If delivered personally, at the time of delivery; or
                      </p>
                      <p class="text-justify text-dark pl-4">
                        16.2.2 If sent via a courier or other recorded delivery service, five (5) days from the
date of posting; or
                      </p>
                      <p class="text-justify text-dark pl-4">
                        16.2.3 If sent by electronic mail, upon electronic confirmation of transmission.
                      </p>
                      <p class="text-justify text-dark pl-4">
                        16.2.4 If deemed receipt under the above paragraphs of this Clause 16.2, is not within
business hours (meaning between 9:00am and 5:30pm West Africa Standard
Time on a Business Day), when business next starts in the place of the deemed
receipt.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">
                      17. GENERAL
                    </h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark pl-4">
                        No Implied Waiver 
                      </p>
                      <p class="text-justify text-dark">
                        17.1 The failure of either Party to insist on strict performance of any covenant or obligation under
these Terms, regardless of the length of time for which such failure continues, shall not be
deemed a waiver of such Party's right to demand strict compliance in the future. No consent
or waiver, express or implied, to or of any breach or default in the performance of any
obligation under these Terms shall constitute a consent or waiver to or of any other breach
or default in the performance of the same or any other obligation.
                      </p>
                      <p class="text-justify text-dark pl-4">
                        Entire Terms
                      </p>
                      <p class="text-justify text-dark">
                        17.2 These Terms constitute the entire Terms between the Parties and supersedes and
extinguishes all previous Terms, promises, assurances, warranties, representations and
understandings between them, whether written or oral, relating to its subject matter. Each
Party agrees that it shall have no remedies in respect of any statement, representation,
assurance or warranty (whether made innocently or negligently) that is not set out or
referenced in these Terms.
                      </p>
                      <p class="text-justify text-dark pl-4">
                        No Variation 
                      </p>
                      <p class="text-justify text-dark">
                        17.3 No variation of these Terms shall be effective unless it is in writing and signed by the parties
or their authorized representatives.
                      </p>
                      <p class="text-justify text-dark pl-4">
                        Assignment
                      </p>
                      <p class="text-justify text-dark">
                        17.4 The rights of the Consumer under these Terms and any document entered into in connection
with or pursuant to the provision of these Terms shall not be assignable. Arnergy may from
time to time assign or transfer all or any of its interest in these Terms and any document
entered in connection with or pursuant to these Terms or sell, charge or otherwise dispose of
its rights in and to the System. Arnergy shall notify the Consumer via email communication
in such circumstances.
                      </p>
                      <p class="text-justify text-dark pl-4">
                        Severability 
                      </p>
                      <p class="text-justify text-dark">
                        17.5 In the event any provision of these Terms is determined to be invalid or unenforceable by
ruling of an arbitrator or court of competent jurisdiction, the remainder of these Terms (and
each of the remaining terms and conditions contained herein) shall remain in full force and
effect.
                      </p>
                      <p class="text-justify text-dark pl-4">
                        Counterparts
                      </p>
                      <p class="text-justify text-dark">
                        17.6 These Terms may be executed in any number of counterparts and the counterparts taken
together shall be deemed to constitute one and the same Terms.
                      </p>
                      <p class="text-justify text-dark pl-4">
                        Force majeure 
                      </p>
                      <p class="text-justify text-dark">
                        17.7 If any of the Parties hereto is prevented from fulfilling its obligations under these Terms by
reason of any supervening event beyond its control (including but not limited to an Act of
God, Natural Disaster, Government Order, Riot, Pandemic or Epidemic or Civil Disorder)
(Force Majeure) the Party unable to fulfil its obligations shall immediately give notice in
writing of this to the other Party and shall do everything in its power, including but not
limited to accepting assistance from third parties or the other Party, to resume full
performance.
                      </p>
                      <p class="text-justify text-dark">
                        17.8 If the period of incapacity exceeds one (1) month, then these Terms shall automatically
terminate unless Parties expressly agree otherwise in writing. The Parties shall be relieved
from liability under these Terms, except in relation to obligations to make payments which
fall due under these Terms.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">
                      18. GOVERNING LAW AND DISPUTE RESOLUTION
                    </h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        18.1 The provisions of these Terms shall be governed by and construed in accordance with the
laws of the Federal Republic of Nigeria.
                      </p>
                      <p class="text-justify text-dark">
                        18.2 In the event of any dispute or claim arising out of or in connection with the interpretation or
implementation of these Terms, the Parties shall endeavour in good faith to resolve any such
dispute through amicable discussion but within a period of thirty (30) days commencing on
the date either Party serves written notice upon the other outlining the nature and substance
of such dispute.
                      </p>
                      <p class="text-justify text-dark">
                        18.3 Where the Parties are unable to amicably settle the dispute within the thirty (30) day period,
such dispute shall be submitted by either or both Parties to arbitration at the Lagos
Multi-Door Courthouse. Both Parties accept that any ruling from such arbitration relating to
the subject matter disputed between the Parties shall be binding and final in all respects
between the Parties.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 class="text-left text-dark">
                      19. AUTHORITY
                    </h3>
                    <div className="child-agree ml-5 pl-5">
                      <p class="text-justify text-dark">
                        In the case of a company as the Purchaser, The individual that has agreed electronically with these
Terms for their respective company warrants that they are fully authorized to do so and that they
(and their respective company) are thereby legally bound by all of the terms and conditions hereof.
                      </p>
                    </div>
                  </div>


                  <hr />
                  <div>
                    <p class="text-left text-dark text-ark">
                      Apply to terms & Conditions
                    </p>
                    <el-checkbox v-model="form.accept"
                      >Click to Accept Terms & Regulations</el-checkbox
                    >

                    <div v-show="form.accept">
                      <button
                        @click="continuePage"
                        class="submit-button"
                        type="button"
                      >
                        Agree and continue
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ArnergyInput from "../ArnergyInput";
import { mapGetters } from "vuex";
import ArnergySelect from "../ArnergySelect.vue";
import {
  Checkbox
  // ...
} from "element-ui";

export default {
  name: "Modal",
  props: ["modalTitle"],
  components: {
    ArnergyInput,
    ArnergySelect,
    "el-checkbox": Checkbox
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getUserAmounty",
      "getDeviceById",
      "getUsers",
      "getTest",
      "getUserAmount",
      "getGroups",
      "getSubgroups",
      "getGroupItems",
      "getDummy",
      "getDevices"
    ])
  },
  data() {
    return {
      costShow: false,
      activeIndex: 0,
      employmentStatus: [
        { id: "Employed", name: "Employed" },
      ],
      businessType: [
        { id: "Oil & Gas", name: "Oil & Gas" },
        { id: "Painter", name: "Painter" },
        { id: "Trader", name: "Trader" }
      ],
      tenures: [
        { id: "6 Months tenure", name: "6 Months tenure" },
        { id: "8 Months tenure", name: "8 Months tenure" },
        { id: "12 Months tenure", name: "12 Months tenure" },
        { id: "9 Months tenure", name: "9 Months tenure" }
      ],
      form: {
        tenure: "",
        income: "",
        employment: "",
        accept: false
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  methods: {
    continuePage() {
      this.$emit("updateStatus");
    }
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

// .modal-mask {
//   margin-top: 30px;
//   position: fixed;
//   z-index: 9998;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(0, 0, 0, 0.5);
//   display: table;
//   transition: opacity 0.3s ease;
// }

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.amt {
  font-size: 25px;
  color: $secondary-color;
  font-weight: bold;
}

.info-footer {
  float: left;
  margin-bottom: 3rem;
}

.modal-container {
  width: 900px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  height: 90vh;
  overflow-y: scroll;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  margin-top: 0;
  color: #42b983;
  position: relative;
  .close-btn {
    color: orangered;
    font-size: 16px;
    position: absolute;
    top: 0;
    right: 0;
  }
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}
.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}

.link {
  color: $primary-color;
  font-weight: bold;
}

.login-title {
  margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
  color: $primary-color;
}

.submit-gif {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  color: white;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/Onboarding/Agreement.vue